const codeFencePattern = /```[^\r\n]*\r?\n([\s\S]*?)```/g;

function parseCodeBlocks(answer) {
    const segments = [];
    let lastIndex = 0;
    let match;

    codeFencePattern.lastIndex = 0;
    while ((match = codeFencePattern.exec(answer)) !== null) {
        if (match.index > lastIndex) {
            segments.push({ type: 'text', value: answer.slice(lastIndex, match.index) });
        }

        segments.push({
            type: 'code',
            value: match[1].replace(/\r?\n$/, ''),
        });
        lastIndex = codeFencePattern.lastIndex;
    }

    if (lastIndex < answer.length) {
        segments.push({ type: 'text', value: answer.slice(lastIndex) });
    }

    return segments;
}

function renderSafeAnswer(element, answer, onCopy) {
    const document = element.ownerDocument || globalThis.document;
    element.replaceChildren();

    for (const segment of parseCodeBlocks(answer)) {
        if (segment.type === 'text') {
            element.appendChild(document.createTextNode(segment.value));
            continue;
        }

        const wrapper = document.createElement('div');
        wrapper.className = 'div';

        const copyContainer = document.createElement('div');
        copyContainer.className = 'copy-container';

        const copyButton = document.createElement('button');
        copyButton.type = 'button';
        const copyIcon = document.createElement('i');
        copyIcon.className = 'fi fi-rr-clipboard';
        copyButton.appendChild(copyIcon);
        copyButton.appendChild(document.createTextNode(' Copy!'));

        const pre = document.createElement('pre');
        const code = document.createElement('code');
        code.textContent = segment.value;
        pre.appendChild(code);

        copyButton.addEventListener('click', () => onCopy(code));
        copyContainer.appendChild(copyButton);
        wrapper.appendChild(copyContainer);
        wrapper.appendChild(pre);
        element.appendChild(wrapper);
    }
}

module.exports = { parseCodeBlocks, renderSafeAnswer };
